/**
 * Limite da descrição/discriminação do serviço na NFS-e.
 *
 * O `InputComponent` cai em 255 quando o textarea não recebe `[maxlength]`,
 * o que cortava o texto da nota. No layout ABRASF (Fortaleza) a
 * `Discriminacao` aceita 2000 caracteres; a API do PlugNotas não impõe limite
 * menor conhecido para `servico[].discriminacao` (confirmar na doc se um
 * município rejeitar).
 */
export const NFSE_DISCRIMINACAO_MAX = 2000;
